// core version + navigation, pagination modules:
import Swiper, { Navigation } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
export default {
    when() {
        return document.querySelectorAll('.slider').length > 0;
    },

    mounted() {
        const swiperCards = new Swiper('.swiper-cards', {
            // configure Swiper to use modules
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-cards-button-next',
                prevEl: '.swiper-cards-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                0: {
                    slidesPerView: 1.3,
                    slidesOffsetAfter: 16,
                    spaceBetween: 16,
                },
                // when window width is >= 480px
                440: {
                    slidesPerView: 1.8,
                    slidesOffsetAfter: 20,
                    spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2.4,
                    spaceBetween: 24,
                    slidesOffsetAfter: 24,
                },
                768: {
                    slidesPerView: 2.7,
                    spaceBetween: 28,
                    slidesOffsetAfter: 28,
                },
                1024: {
                    slidesPerView: 3.2,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
                1280: {
                    slidesPerView: 3.7,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
                1536: {
                    slidesPerView: 4.8,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                }
            },
        });

        const swiperServices = new Swiper('.swiper-services', {
            // configure Swiper to use modules
            modules: [Navigation],
            navigation: {
                nextEl: '.swiper-services-button-next',
                prevEl: '.swiper-services-button-prev',
            },
            breakpoints: {
                // when window width is >= 320px
                0: {
                    slidesPerView: 1.1,
                    slidesOffsetAfter: 16,
                    spaceBetween: 16,
                },
                // when window width is >= 480px
                440: {
                    slidesPerView: 1.6,
                    slidesOffsetAfter: 20,
                    spaceBetween: 20,
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 2.3,
                    spaceBetween: 24,
                    slidesOffsetAfter: 24,
                },
                768: {
                    slidesPerView: 2.6,
                    spaceBetween: 28,
                    slidesOffsetAfter: 28,
                },
                1024: {
                    slidesPerView: 3.4,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
                1280: {
                    slidesPerView: 3.7,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                },
                1536: {
                    slidesPerView: 4.8,
                    spaceBetween: 32,
                    slidesOffsetAfter: 32,
                }
            },
        });
    },
};
